import { useEffect, useState } from "react";

import { SortDropdownValue } from "@/modules/common/components";
import { useFilters } from "@/modules/common/filters";
import { FILTER_KEYS } from "@/modules/common/filters/keys";
import { usePagination } from "@/modules/common/hooks/usePagination";
import { AdminAneelTariffSortField } from "@/modules/common/types/AneelTariffs.enum";
import { ListAneelTariffsDto } from "@/service/dto/admin-aneel-tariffs";

import { ANEEL_TARIFF_FILTER_FIELDS } from "../../constants/AneelTariffFilterFields";
import useAneelTariffList from "../../hooks/useAneelTariffList";
import TariffsFilterBar from "./TariffsFilterBar";
import TariffsList from "./TariffsList";

const TariffsTab = () => {
  const [sort, setSort] = useState<SortDropdownValue<AdminAneelTariffSortField> | null>(null);

  const filters = useFilters<ListAneelTariffsDto>({
    fields: ANEEL_TARIFF_FILTER_FIELDS,
    filterKey: FILTER_KEYS.ANEEL_TARIFFS,
  });

  const { page, setPage, limit, setPageSize } = usePagination();

  const filtersKey = JSON.stringify(filters.queryParams);
  const sortKey = sort ? `${sort.field}:${sort.order}` : "";
  useEffect(() => {
    setPage(1);
  }, [filtersKey, sortKey]);

  const {
    data: tariffs,
    isLoading: isTariffsLoading,
    isFetching: isTariffsFetching,
  } = useAneelTariffList({
    ...filters.queryParams,
    sortBy: sort?.field,
    sortOrder: sort?.order,
    page,
    limit,
  });

  return (
    <div className="flex flex-col gap-4">
      <TariffsFilterBar filters={filters} sort={sort} onSortChange={setSort} />

      <TariffsList
        data={tariffs}
        isLoading={isTariffsLoading}
        isFetching={isTariffsFetching}
        limit={limit}
        onChangePage={setPage}
        onChangePageSize={setPageSize}
      />
    </div>
  );
};

export default TariffsTab;
